import { makeAutoObservable } from 'mobx';

type SelectedFilters = {
  [key: string]: string[];
};

export class StateFilterStore {
  hideFilter = false;
  // Состояние выбранных фильтров
  selectedFilters: SelectedFilters = {};
  // Состояние выбора всех элементов
  selectAllState: Record<string, boolean> = {};
  // Все уникальные значения для каждого заголовка
  uniqueValues: Record<string, string[]> = {};

  constructor() {
    makeAutoObservable(this);
  }

  // Установка видимости фильтра
  setHideFilter(value: boolean) {
    this.hideFilter = value;
  }

  // Установка уникальных значений для фильтров
  setUniqueValues(values: Record<string, string[]>) {
    this.uniqueValues = values;
  }

  // Метод для изменения состояния отдельного чекбокса (аналог handleCheckboxChange из хука)
  handleCheckboxChange(key: string, value: string) {
    const currentValues = this.selectedFilters[key] || [];
    const newValues = currentValues.includes(value)
      ? currentValues.filter((v) => v !== value)
      : [...currentValues, value];

    this.selectedFilters = {
      ...this.selectedFilters,
      [key]: newValues,
    };
  }

  // Метод для выбора всех значений заголовка (аналог handleSelectAllChange из хука)
  handleSelectAllChange(key: string, selectAll: boolean) {
    this.selectedFilters = {
      ...this.selectedFilters,
      [key]: selectAll ? this.uniqueValues[key] || [] : [],
    };

    this.selectAllState = {
      ...this.selectAllState,
      [key]: selectAll,
    };
  }

  // Метод для установки фильтров из результатов поиска
  setFiltersFromSearch(filters: SelectedFilters) {
    this.selectedFilters = { ...filters };
  }

  // Метод для проверки, есть ли выбранные фильтры
  hasSelectedFilters(): boolean {
    return Object.values(this.selectedFilters).some(
      (values) => values.length > 0,
    );
  }

  // Метод для сброса всех фильтров
  resetFilters() {
    this.selectedFilters = {};
    this.selectAllState = {};
    this.uniqueValues = {};
  }
}

const stateFilterStore = new StateFilterStore();
export default stateFilterStore;
